import { trpc } from "#/lib/trpc/client"
import { HealthieAnswer } from "@internal/telemedicine"
import { useMutation } from "@tanstack/react-query"

export function useSubmitIntakeForm() {
  return useMutation({
    mutationFn: ({ formId, answers }: { formId: string; answers: HealthieAnswer[] }) =>
      trpc.telemedicine.submitForm.mutate({ formId, answers })
  })
}
